export default __webpack_public_path__ + "static/media/fringe_shape.2fe9282a.jpeg";